/* eslint-disable no-console */
import "./create-nonce";
import { registerApplication, start, setBootstrapMaxTime, setMountMaxTime, getMountedApps } from "single-spa";
import PubSub from "pubsub-js";

export const publish = async (event, data) => {
	await PubSub.publish(event, data);
};

export const subscribe = (event, callback) => PubSub.subscribe(event, callback);
export const unsubscribe = token => PubSub.unsubscribe(token);
export const countSubscriptions = token => PubSub.countSubscriptions(token);

function showWhenPrefix(routes) {
	return function(location) {
		// to handle case sensitive condition if URL enter by user
		return routes.some(route => location.pathname.toLowerCase().startsWith(route.toLowerCase()));
	};
}
function showWhenPrefixLogin(routes) {
	return function(location) {
		return routes.some(route => location.pathname.startsWith(route)) || location.pathname === "/";
	};
}
let microFrontendsToRegister = [
	{
		name: "@Phishlabs/Login",
		app: () => loadApp("@Phishlabs/Login", "Login"),
		activeWhen: showWhenPrefixLogin(["/"])
	}
];
if (window.__REACT_APP_IS_ENABLED_DRP_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/drp",
		app: () => loadApp("@Phishlabs/drp", "DRP"),
		activeWhen: showWhenPrefix(["/drp"])
	});
}
if (window.__REACT_APP_IS_ENABLED_EIR_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/EIR",
		app: () => loadApp("@Phishlabs/EIR", "EIR"),
		activeWhen: showWhenPrefix(["/eir"])
	});
}

if (window.__REACT_APP_IS_ENABLED_SOAR_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/HOOKSET",
		app: () => loadApp("@Phishlabs/HOOKSET", "SOAR"),
		activeWhen: showWhenPrefix(["/soar"])
	});
}
if (window.__REACT_APP_IS_ENABLED_CPS_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/CPS",
		app: () => loadCPS_UIApp("@Phishlabs/CPS", "CPS"),
		activeWhen: showWhenPrefix(["/home/cps"])
	});
}
if (window.__REACT_APP_IS_ENABLED_CPS_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/CPS-legacy",
		app: () => loadCPS_Admin_UIApp("@Phishlabs/CPS-legacy", "CPS-legacy"),
		activeWhen: showWhenPrefix(["/home/legacy-cps"])
	});
}

if (window.__REACT_APP_IS_ENABLED_SIDEBAR_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/Sidebar",
		app: () => loadApp("@Phishlabs/Sidebar", "Sidebar"),
		activeWhen: showWhenPrefix(["/home", "/eir", "/drp"])
	});
}
if (window.__REACT_APP_IS_ENABLED_WORK_QUEUE_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/Work-Queue",
		app: loadWork_QueueApp,
		activeWhen: showWhenPrefix(["/home/work-queue"])
	});
}
if (window.__REACT_APP_IS_ENABLED_SEA_OPS_UI_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/SEA-OPS-UI",
		app: loadSEA_OPS_UIApp,
		activeWhen: showWhenPrefix(["/home/work-queue/sea-ops-ui", "/eir/incidents/sea-ops-ui"])
	});
}
if (window.__REACT_APP_IS_ENABLED_ACTIVITY_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/Activity",
		app: loadActivityApp,
		activeWhen: showWhenPrefix(["/home/work-queue/sea-ops-ui","/eir/incidents/"])
	});
}
if (window.__REACT_APP_IS_ENABLED_OPS_PORTAL_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/ops-portal",
		app: loadOPS_PORTALApp,
		activeWhen: showWhenPrefix(["/home/work-queue/ops-portal"])
	});
}
if (window.__REACT_APP_IS_ENABLED_DOMAINS_CONTENT_MONITORING_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/dng-opsportal-cm",
		app: LoadOPS_PORTAL_CMApp,
		activeWhen: showWhenPrefix(["/home/work-queue/domains-content-monitoring"])
	});
}

if (window.__REACT_APP_IS_ENABLED_OPEN_WEB_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/ong-opsportal",
		app: LoadOpenWebPortalApp,
		activeWhen: showWhenPrefix(["/home/work-queue/open-web-validation"])
	});
}

if (window.__REACT_APP_IS_ENABLED_DOMAINS_LOOKBACKS_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/dng-lookbacks",
		app: LoadDomainLookbacksApp,
		activeWhen: showWhenPrefix(["/home/domain-lookbacks-results"])
	});
}

if (window.__REACT_APP_IS_ENABLED_AMUI_APP === "true") {
	microFrontendsToRegister.push({
		name: "@Phishlabs/amui",
		app: () => loadApp("@Phishlabs/amui", "Automatic Mitigation"),
		activeWhen: showWhenPrefix(["/home/amui"])
	});
}

microFrontendsToRegister.map(({ name, app, activeWhen }) =>
	registerApplication({
		name,
		app,
		activeWhen
	})
);

/**
 * timeout is a helper function that creates a timer that can be used as a wait() for promise chaining or async await function
 *
 * @param {number} ms The number of milliseconds to set the internal timer
 * @return {Promise} a promise that will resolve when the timeout completes
 */
const timeout = ms => {
	return new Promise(resolve => {
		setTimeout(resolve, ms);
	});
};

/**
 * waitForAppToMount is a helper function intended to be used in loading functions for apps that have loading dependencies
 * on other apps, such as mount targets or other DOM content required for another app before it loads.  It uses the
 * singlespa API to fetch the mounted apps and looks for the given app reference.  It leverages the timeout helper to
 * create a blocking wait() style pause for 500 ms up to 5 times.  This gives the target
 * app up to 2.5 seconds to mount into the DOM before proceeding.
 * @param app
 * @return {Promise<void>}
 */
async function waitForAppToMount(app) {
	let attempts = 5;
	let mountedAppNames = getMountedApps();
	while (!mountedAppNames.includes(app) && attempts > 0) {
		await timeout(500);
		mountedAppNames = getMountedApps();
		attempts--;
	}
}

async function loadApp(importApp, errorAppName) {
	await Promise.resolve();
	placeLoader();
	return System.import(importApp)
		.then(() => {
			return System.import(importApp);
		})
		.catch(() => {
			errorOnAPIFailed(errorAppName);
		})
		.finally(() => {
			!importApp === "@Phishlabs/Login" && removeLoader();
		});
}
async function loadCommentsApp() {
	await Promise.resolve();
	return System.import("@Phishlabs/Comments").catch(() => {
		errorOnAPIFailed("Comments");
	});
}

async function loadActivityApp() {
	await Promise.resolve();
	await waitForAppToMount("@Phishlabs/SEA-OPS-UI");
	return System.import("@Phishlabs/Activity").catch(() => {
		errorOnAPIFailed("Activity");
	});
}

async function loadOPS_PORTALApp() {
	await Promise.resolve();
	await waitForAppToMount("@Phishlabs/Work-Queue");
	return System.import("@Phishlabs/ops-portal").catch(err => {
		errorOnAPIFailed("OPS-PORTAL");
	});
}

async function LoadOPS_PORTAL_CMApp() {
	await waitForAppToMount("@Phishlabs/Work-Queue");
	return System.import("@Phishlabs/dng-opsportal-cm").catch(err => {
		errorOnAPIFailed("Domains Content Monitoring");
	});
}

async function LoadOpenWebPortalApp() {
	await waitForAppToMount("@Phishlabs/Work-Queue");
	return System.import("@Phishlabs/ong-opsportal").catch(err => {
		errorOnAPIFailed("Open Web Portal");
	});
}

async function LoadDomainLookbacksApp() {
	await Promise.resolve();
	placeLoader();
	return System.import("@Phishlabs/dng-lookbacks")
		.catch(err => {
			errorOnAPIFailed("Domains Lookbacks Results");
		})
		.finally(() => {
			removeLoader();
		});
}

async function loadSEA_OPS_UIApp() {
	await Promise.resolve();
	await waitForAppToMount("@Phishlabs/Work-Queue");
	return System.import("@Phishlabs/SEA-OPS-UI").catch(err => {
		errorOnAPIFailed("SEA-OPS-UI");
	});
}
async function loadWork_QueueApp() {
	await Promise.resolve();
	placeLoader();
	return System.import("@Phishlabs/Work-Queue")
		.catch(err => {
			errorOnAPIFailed("Work Queue");
		})
		.finally(() => {
			removeLoader();
		});
}

async function loadCPS_UIApp() {
	await Promise.resolve();
	placeLoader();
	return System.import("@Phishlabs/CPS")
		.catch(err => {
			errorOnAPIFailed("CPS-UI");
		})
		.finally(() => {
			removeLoader();
		});
}

async function loadCPS_Admin_UIApp() {
	await Promise.resolve();
	placeLoader();
	return System.import("@Phishlabs/CPS-legacy")
		.catch(err => {
			errorOnAPIFailed("CPS-Admin-UI");
		})
		.finally(() => {
			removeLoader();
		});
}

function errorOnAPIFailed(appName) {
	let loaderDiv = document.getElementById("root");
	loaderDiv && loaderDiv.classList.remove("root-loader");
	let div = document.createElement("div");
	div.id = "error-div";
	document.body.appendChild(div);
	document.getElementById("root").className = "root-error";
	document.getElementById("error-div").textContent = `Something went wrong while ${appName} app loading`;
}

function placeLoader() {
	var loaderDiv = document.getElementById("root");
	loaderDiv && loaderDiv.classList.add("sr-spinner");
	loaderDiv && loaderDiv.classList.add("root-loader");
}
function microfrontendplaceLoader() {
	var loaderDiv = document.getElementById("root");
	loaderDiv && loaderDiv.classList.add("sr-spinner");
}
function removeLoader() {
	var loaderDiv = document.getElementById("root");
	loaderDiv && loaderDiv.classList.remove("sr-spinner");
	loaderDiv && loaderDiv.classList.remove("root-loader");
}

setBootstrapMaxTime(3000, true);
setMountMaxTime(3000, true);
start();
